<template>
    <div class="menu-bar">
        <div class="row no-gutters">
            <div class="col-3 menu-col">
                <img @click="clickProfile()" v-show="currentTab == 'profile'" src="@/assets/img/00-menubar/ic-profile-active@3x.png">
                <img @click="clickProfile()" v-show="currentTab != 'profile'" src="@/assets/img/00-menubar/ic-profile-inactive@3x.png">
            </div>
            <div class="col-3 menu-col">
                <img @click="clickGiftList()" v-show="currentTab == 'giftlist'" src="@/assets/img/00-menubar/Giftlist@3x.png">
                <img @click="clickGiftList()" v-show="currentTab != 'giftlist'" src="@/assets/img/00-menubar/Giftlist-inactive@3x.png">
            </div>
            <div class="col-3 menu-col">
                <img @click="clickReward()" v-show="currentTab == 'reward'" src="@/assets/img/00-menubar/svgg@3x_active.png">
                <img @click="clickReward()" v-show="currentTab != 'reward'" src="@/assets/img/00-menubar/svgg@3x.png">
            </div>
            <div class="col-3 menu-col">
                <img @click="clickStore()" v-show="currentTab == 'store'" src="@/assets/img/00-menubar/ic-store-active@3x.png">
                <img @click="clickStore()" v-show="currentTab != 'store'" src="@/assets/img/00-menubar/ic-store-inactive@3x.png">
            </div>
        </div>
    </div>
</template>
<script>

import Account from '@/helper/AccountHelper.js';
/**
 * @property {Boolean} lbl
 * @property {String} currentTab
 */
export default {
    name: 'top-bar',// <top-bar>
    props: {
        currentTab: String
    },
     data: function() {
        return {
        //    user: Account.getCacheUser(),
        };
    },
    created: function() {

    },
    methods: {

        clickProfile: function () {

            Account.loginStatus().then((status) => {
                if (status) {
                    this.$router.push("/profile");
                } else {
                    this.$router.push("/register");
                }
            })
            .catch(() => {
                this.$router.push("/register");
            });

        },
        clickReward: function () {

            Account.loginStatus().then((status) => {
                if (status) {
                    this.$router.push("/booking");
                } else {
                    this.$router.push("/register");
                }
            })
            .catch(() => {
                this.$router.push("/register");
            });

        },
        clickStore: function () {
            this.$router.push("/storelocation");
        },
        clickGiftList: function () {

            Account.loginStatus().then((status) => {
                if (status) {
                    this.$router.push("/giftlist");
                } else {
                    this.$router.push("/register");
                }
            })
            .catch(() => {
                this.$router.push("/giftlist");
            });
        }
    },
}
</script>
<style lang="scss" scoped>
.menu-bar {
    position: fixed;
    bottom: 0;
    background-color: #000;
    width: 100%;

    .menu-col {
        text-align: center;
        padding: 7.5px 0;
        img {
            height: 25px;
        }
    }

}

</style>
